import { storyblokInit, type SbSvelteComponentsMap } from '@storyblok/svelte';

import type { PageLoad } from './$types';
import { getLoadedComponentsMap } from '$lib/componentsMap';

export const load: PageLoad = async ({ data }) => {
  const clientComponents = await getLoadedComponentsMap(data.neededComponents);

  storyblokInit({
    components: clientComponents as SbSvelteComponentsMap,
  });

  return data;
};
